import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryServiceType as LinkDeliveryServiceType } from '../links/DeliveryServiceType';
import { type DeliveryPickupPoints as SchemaDeliveryPickupPoints } from '../schemas/DeliveryPickupPoints';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetDeliveryPickupPointsContentType = '' as const;
export type GetDeliveryPickupPointsRequest = undefined;
export type GetDeliveryPickupPointsResponses = LinkCommonErrorResponses & {
    /**
     * @description Delivery dates in unixtime format
     */
    '200': {
        'application/json': SchemaDeliveryPickupPoints;
    };
};
export type GetDeliveryPickupPointsResponseSuccess = GetDeliveryPickupPointsResponses['200']['application/json'];
export type GetDeliveryPickupPointsSearchParams = {
    type: string;
    longitudeFrom?: number;
    longitudeTo?: number;
    latitudeFrom?: number;
    latitudeTo?: number;
    pickup_point_id?: string;
    service_type?: LinkDeliveryServiceType;
    hasFittingRoom?: boolean;
    hasPaymentOnDelivery?: boolean;
    order_id?: string;
};
export type GetDeliveryPickupPointsPathParameters = {
    store_slug: string;
};
export const GetDeliveryPickupPointsUrl = '/{store_slug}/delivery/points' as const;
export const GetDeliveryPickupPointsMethod = 'GET' as const;
export const getGetDeliveryPickupPointsUrl = (params: GetDeliveryPickupPointsPathParameters) =>
    GetDeliveryPickupPointsUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetDeliveryPickupPointsPathParameters) =>
        String(params[param])
    );
